import { portableLinks } from '../../utils/reactUtils'


const withLinks = {
  marks: portableLinks,
}

export default withLinks